import { Popup, Heading, Body, Label, Button } from './ui';
import { playClick } from '../sounds';
import './HowToPlay.css';

interface Props {
  onClose: () => void;
  onGoToTutorial?: () => void;
}

export function HowToPlay({ onClose, onGoToTutorial }: Props) {
  return (
    <Popup aria-label="Quick Guide" onDismiss={onClose} maxWidth={640}>
      <div className="help-content">
        <div className="help-header">
          <Heading>Quick Guide</Heading>
          <div className="help-header-actions">
            {onGoToTutorial && (
              <Button variant="ghost" onClick={() => { playClick(); onGoToTutorial(); }}>
                Open Full Tutorial
              </Button>
            )}
            <Button
              variant="secondary"
              size="circle"
              className="top-bar-btn"
              onClick={() => { playClick(); onClose(); }}
              aria-label="Close quick guide"
            >
              {'\u2715'}
            </Button>
          </div>
        </div>

        <div className="help-body">
          <div className="help-scroll">
            <div className="help-group">
              <div className="help-section">
                <div className="help-section-title">Goal</div>
                <Body>Fill in cells to reveal the hidden picture.</Body>
              </div>

              <div className="help-section">
                <div className="help-section-title">Clues</div>
                <Body>
                  Numbers on the left and top tell you how many consecutive filled
                  cells are in each row or column.
                </Body>
                <Body>
                  For example, <Label as="span">2 3</Label> means there is a group of 2
                  filled cells, at least one empty cell, then a group of 3 filled
                  cells.
                </Body>
              </div>

              <div className="help-section">
                <div className="help-section-title">Controls</div>
                <ul className="help-list">
                  <Body as="li">
                    <Label as="span">Left click</Label> or <Label as="span">Space</Label> &mdash; Fill / unfill a cell
                  </Body>
                  <Body as="li">
                    <Label as="span">Right click</Label> or <Label as="span">X</Label> &mdash; Mark / unmark a cell
                  </Body>
                  <Body as="li">
                    <Label as="span">Click &amp; drag</Label> &mdash; Fill or mark multiple cells
                  </Body>
                  <Body as="li">
                    <Label as="span">Arrow keys</Label> &mdash; Move selection
                  </Body>
                  <Body as="li">
                    <Label as="span">Ctrl+Z</Label> / <Label as="span">Ctrl+Y</Label> &mdash; Undo / Redo
                  </Body>
                  <Body as="li">
                    <Label as="span">Esc</Label> &mdash; Back to menu
                  </Body>
                </ul>
              </div>

              <div className="help-section">
                <div className="help-section-title">Tips</div>
                <Body>
                  Use marks (X) on cells you know are empty. Completed rows and
                  columns will dim automatically.
                </Body>
              </div>
            </div>
          </div>

          <Button variant="primary" size="wide-sm" className="help-close-btn" onClick={() => { playClick(); onClose(); }}>
            Got it!
          </Button>
        </div>
      </div>
    </Popup>
  );
}
